import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {clearCurrentProject} from "../../store/reducers/projectSlice";
import {Container, Nav, ProjectInfo, ProjectLink, Title, UserLabel} from "./styled";

const StatusBar = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {email} = useSelector((state) => state.user);
  const currentProject = useSelector((state) => state.project.currentProject);

  useEffect(() => {
    if (!location.pathname.startsWith('/projects/')
      && !location.pathname.startsWith('/configurations/')) {
      dispatch(clearCurrentProject());
    }
  }, [location, dispatch]);

  return (
    <Container>
      <Title>
        {email && (
          <>
            <UserLabel>User:</UserLabel> {email}
          </>
        )}
      </Title>
      <Nav>
      </Nav>
      {currentProject && (
        <ProjectInfo>
          <ProjectLink href={'/projects/' + currentProject.projectId}>
            Project #{currentProject.projectId}
          </ProjectLink>
          : {currentProject.name}
        </ProjectInfo>
      )}
    </Container>
  );
}

export default StatusBar;